import React from 'react';

export function roundDouble (val, decimals) {
	const div = Math.pow(10, decimals || 2)
  return Math.round((val + Number.EPSILON) * div) / div;
}

export function formatLong(val) {
	return <span>{ formatLongData(val) }</span>;
}

export function long(val) {
	return formatLongData(val);
}

export function formatLongData(val) {
	val = val || 0;
	val = (isNaN(val)) ? 0 : val;
	return new Intl.NumberFormat().format(Number.parseFloat(val).toFixed(0));
}

export function double (val, currency, precision) {
	precision = precision || 2;
	return (currency ? currency : '$') + new Intl.NumberFormat().format(Number.parseFloat(val).toFixed(precision));
}

export function formatDouble (val, currency, precision) {
	precision = precision || 2;
	return <span>{ double (val, currency, precision) }</span>;
	// return <span>{ (currency ? currency : '$') + Number.parseFloat(val).toFixed(precision) }</span>;
}

export function formatDateTime(val) {
	val = '' + val;
	return <span>{ val.substring(0, val.indexOf(':')).replace('T', ' ') + ':00' }</span>;
}

export function formatDate(val) {
	val = '' + val;
	return <span>{ val.substring(0, val.indexOf('T')) }</span>;
}

export function CustomDateField ({ record }) {
  let date = '' + record.date;
  date = date.substring(0, date.indexOf('T'))
  return <span><nobr>{date}</nobr></span>;
};

export const BIDDERS_REQUIRE_SITE_ID = [312, 313, 400, 410, 326, 330, 408, 323, 350, 320, 409, 363, 364, 332, 411, 425];
export const BIDDERS_REQUIRE_SITE_ID_LABEL = {
	350: 'Zone ID',
	323: 'Zone ID',
	309: 'Zone ID',
	312: 'Placement ID',
	313: 'Placement ID',
	400: 'Placement ID',
	326: 'Placement ID',
	330: 'Placement ID',
	408: 'Placement ID',
	320: 'Placement ID',
	409: 'Placement ID',
	363: 'Placement ID',
	425: 'Placement ID',
	332: 'Placement ID',
	411: 'Placement ID',
	364: 'Zone ID',
};
export const BIDDERS_SELECTABLE = [
	// { id: 101, name: 'Google AdSense (101)' },
	{ id: 307, name: 'Google AdExchange Tag (307)' },
	{ id: 607, name: 'AdExchange Tag OpsCo (607)' },
	{ id: 606, name: 'NoBid Backfill Tag (606)' },
	// { id: 507, name: 'AdExchange Tag West Seven Media (507)' },
	// { id: 707, name: 'AdExchange Tag Media Tradecraft (707)' },
	// { id: 807, name: 'AdExchange Tag 152 Media (807)' },
	// { id: 907, name: 'AdExchange Tag SIA Setupad (907)' },
	// { id: 706, name: 'AdExchange Tag Geniee International (706)' },
	// { id: 705, name: 'AdExchange Tag Snigel (705)' },
	// { id: 711, name: 'AdExchange Tag 1XL (711)' },
	// { id: 713, name: 'AdExchange Tag VerticalScope (713)' },
	// { id: 715, name: 'AdExchange Tag Eight Network (715)' },
	{ id: 379, name: 'Bidswitch Banner DM (379)' },
	{ id: 309, name: 'Gumgum (309)' },
	{ id: 310, name: 'Sovrn (310)' },
	{ id: 312, name: 'Appnexus (312)' },
	{ id: 313, name: 'Appnexus Native (313)' },
	{ id: 400, name: 'Appnexus Video (400)' },
	{ id: 326, name: 'Appnexus 2 (326)' },
	{ id: 330, name: 'Appnexus 2 Native (330)' },
	{ id: 408, name: 'Appnexus 2 Video (408)' },
	{ id: 323, name: 'Rubicon/Magnite DM (323)' },
	{ id: 350, name: 'Rubicon/Magnite (350)' },
	{ id: 314, name: 'Yieldlift (314)' },
	{ id: 401, name: 'Gumgum Video (401)' },
	{ id: 320, name: 'Mediafuse Banner (320)' },
	{ id: 409, name: 'Mediafuse Video (409)' },
	{ id: 332, name: 'Sonobi (332)' },
	{ id: 411, name: 'Sonobi Video (411)' },
	{ id: '', name: '--- Mediafuse Network ---', disabled: true },
	{ id: 363, name: 'Appnexus Banner (35448404) (363)' },
	{ id: 425, name: 'Appnexus Video (MF Network) (425)' },
	{ id: 364, name: 'Rubicon/Magnite Banner (MF Network) (364)' },
];
export const BIDDERS_PREDICTORS = [
	{ id: 0, name: '- No Default Bidder -' },
	// { id: 101, name: 'Google AdSense (101)' },
	{ id: 307, name: 'Google AdExchange Tag (307)' },
	{ id: 607, name: 'AdExchange Tag OpsCo (607)' },
	{ id: 606, name: 'NoBid Backfill Tag (606)' },
	// { id: 507, name: 'AdExchange Tag West Seven Media (507)' },
	// { id: 707, name: 'AdExchange Tag Media Tradecraft (707)' },
	// { id: 807, name: 'AdExchange Tag 152 Media (807)' },
	// { id: 907, name: 'AdExchange Tag SIA Setupad (907)' },
	// { id: 706, name: 'AdExchange Tag Geniee International (706)' },
	// { id: 705, name: 'AdExchange Tag Snigel (705)' },
	// { id: 711, name: 'AdExchange Tag 1XL (711)' },
	// { id: 713, name: 'AdExchange Tag VerticalScope (713)' },
	// { id: 715, name: 'AdExchange Tag Eight Network (715)' }
];
export const BIDDERS_PREDICTION_DISABLABLE = BIDDERS_PREDICTORS.filter(x=>x.id>101).map(x=>x.id);

export const PACES = [
	{ id: 0, name: '0%' },
	{ id: 1, name: '1%' },
	{ id: 2, name: '2%' },
	{ id: 3, name: '3%' },
	{ id: 4, name: '4%' },
	{ id: 5, name: '5%' },
	{ id: 6, name: '6%' },
	{ id: 7, name: '7%' },
	{ id: 8, name: '8%' },
	{ id: 9, name: '9%' },
	{ id: 10, name: '10%' },
	{ id: 11, name: '11%' },
	{ id: 12, name: '12%' },
	{ id: 15, name: '15%' },
	{ id: 20, name: '20%' },
	{ id: 25, name: '25%' },
	{ id: 30, name: '30%' },
	{ id: 35, name: '35%' },
	{ id: 40, name: '40%' },
	{ id: 45, name: '45%' },
	{ id: 50, name: '50%' },
	{ id: 55, name: '55%' },
	{ id: 60, name: '60%' },
	{ id: 65, name: '65%' },
	{ id: 70, name: '70%' },
	{ id: 75, name: '75%' },
	{ id: 80, name: '80%' },
	{ id: 85, name: '85%' },
	{ id: 90, name: '90%' },
	{ id: 95, name: '95%' },
	{ id: 99, name: '99%' },
	{ id: 100, name: '100%' },
];

export const SITE_TYPES = [
  { id: "site", name: 'Site' },
  { id: 'app', name: 'App' }
];

export function formatSiteName(site) {
	if (site && site.publisher_name) {
		return `${site.name} (${site.publisher_name})`
	} else if (site && site.adunit_path) {
		const pathArr = site.adunit_path.split('/')
		return `${pathArr[pathArr.length-1]} (${pathArr[pathArr.length-2]})`
	};
	return ''
}

export function siteFormFilter(searchText, formData) {
	if (formData?.publisher_id?.length > 0) return { search_name: searchText, publisher_id: formData.publisher_id };
	else return { search_name: searchText };
}